<template>
    <transition>
    <div class="container-fluid page-content">
        <!-- Modern Page Header -->
        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center page-header-row gap-3 mb-4">
            <div>
                <h4 class="page-title text-slate-800 fw-bold mb-1">Role Permissions</h4>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item"><a href="/" class="text-muted"><i class="fas fa-home me-1"></i>Home</a></li>
                        <li class="breadcrumb-item"><a href="/role" class="text-muted">User Settings</a></li>
                        <li class="breadcrumb-item active text-indigo fw-medium" aria-current="page">Role Permissions</li>
                    </ol>
                </nav>
            </div>
            <div>
                <a href="/role" class="btn btn-outline-premium d-flex align-items-center gap-2">
                    <i class="fas fa-arrow-left"></i> Back to Roles
                </a>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card border-0 shadow-sm table-card">
                    <div class="card-header bg-white border-bottom-0 pt-4 px-4 d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="fw-bold m-0 text-slate-800 d-flex align-items-center gap-2">
                                <i class="fas fa-user-shield text-indigo"></i> Role Permission ({{ this.role.name }})
                            </h5>
                            <p class="text-muted mb-0 small mt-1">Configure access control levels for this user role.</p>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <form @submit.prevent="submitForm()">
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0" v-if="!loading">
                                    <thead class="bg-light">
                                        <tr>
                                            <th width="20%" class="moduleHead text-start py-3">Module Name</th>
                                            <th width="20%" class="moduleHead text-start py-3">Sub Module Name</th>
                                            <th width="60%" class="py-3">
                                                <div class="d-flex align-items-center gap-3">
                                                    <span>Permissions</span>
                                                    <div class="vertical-divider"></div>
                                                    <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 select-all-label">
                                                        <input type="checkbox" class="all_permission" :checked="isCheckAll" @change="checkedAll($event.target.checked)">
                                                        <span>Select All</span>
                                                    </label>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(parent_module, i) in menu_and_permissions" :key="i">
                                        <!-- Main with Sub-Module Permissions -->
                                        <template v-if="parent_module.sub_modules.length > 0">
                                            <tr v-for="(sub_module, iSub) in parent_module.sub_modules" :key="iSub">
                                                <td style="text-align: left; vertical-align: middle;"
                                                    v-if="iSub === 0"  
                                                    :rowspan="parent_module.sub_modules.length"
                                                    class="module-cell bg-light border-end"
                                                >   
                                                    <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 fw-bold">
                                                        <input type="checkbox" :id="'module_id_'+ i" :value="parent_module.id" v-model="form.module_permissions" @change="checkModule($event)">
                                                        <span>{{ parent_module.name }}</span>
                                                    </label>
                                                </td>
                                                <td class="submodule-cell border-end align-middle">
                                                    <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 fw-semibold text-slate-700">
                                                        <input type="checkbox" :id="'sub_module_id_'+ iSub" :value="sub_module.id" :refs="parent_module.id" v-model="form.sub_module_permissions" @change="checkSubModule($event)">
                                                        <span>{{ sub_module.name }}</span>
                                                    </label>
                                                </td> 
                                                <td class="actions-cell align-middle">
                                                    <div class="d-flex flex-wrap gap-3 py-1" v-if="sub_module.actions.length > 0">
                                                        <div v-for="(permission, j) in sub_module.actions" :key="j">
                                                            <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 text-slate-600 font-medium">
                                                                <input type="checkbox" :id="'permission_id'+ j" :value="permission.id" :refs="sub_module.id" :parent_id="parent_module.id" child_type="sub_module"  v-model="form.role_permissions" @change="checkSinglePermission($event)"> 
                                                                <span>{{ permission.name }}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>  
                                        </template>
                                        <!-- Main Module Permissions -->
                                        <template v-else>
                                            <tr>
                                                <td style="text-align: left; vertical-align: middle;" class="module-cell bg-light border-end">   
                                                    <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 fw-bold">
                                                        <input type="checkbox" :id="'module_id_'+ i" :value="parent_module.id" v-model="form.module_permissions" @change="checkModule($event)">
                                                        <span>{{ parent_module.name }}</span>
                                                    </label>
                                                </td> 
                                                <td class="text-muted bg-slate-50 italic submodule-cell border-end align-middle">N/A</td> 
                                                <td class="actions-cell align-middle">
                                                    <div class="d-flex flex-wrap gap-3 py-1" v-if="parent_module.actions.length > 0">
                                                        <div v-for="(permission, j) in parent_module.actions" :key="j">
                                                            <label class="form-checkbox-premium d-inline-flex align-items-center gap-2 m-0 text-slate-600 font-medium">
                                                                <input type="checkbox" :id="'permission_id'+ j" :value="permission.id" :refs="parent_module.id" :parent_id="parent_module.id" child_type="module" v-model="form.role_permissions" @change="checkSinglePermission($event)"> 
                                                                <span>{{ permission.name }}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>  
                                        </template>
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td colspan="3" class="text-center bg-white py-4 border-0">
                                                <button type="submit" class="btn btn-premium px-5 py-2.5 shadow" :disabled="disabled">
                                                    <span v-show="isSubmit" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    <i class="fas fa-save me-2" v-show="!isSubmit"></i>{{btn}} Permissions
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>

                                <!-- Loading State -->
                                <div class="text-center py-5" v-if="loading">
                                    <div class="spinner-premium mb-3 mx-auto"></div>
                                    <h5 class="text-muted fw-semibold">Loading Permissions</h5>
                                    <p class="text-muted mb-0 small">Please wait a moment...</p>
                                </div>
                            </div>
                        </form>
                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct';
import axios from "axios";
import Modal from "./../helper/Modal.vue";
import { ref, onMounted, getCurrentInstance} from "vue";
import Form from "vform";
export default {
    name: "PosLeftbar",
    components: {
        
    },
    data() {
        return {
            loading: true,
            role_id: this.$route.params.id,
            isSubmit: false,
            disabled: false,
            errors: {},
            btn:'Update',
            role: '',
            sub_modules: [],
            permissions: [],
            menu_and_permissions: [],
            form:{
                role_permissions:[],
                module_permissions: [],
                sub_module_permissions: [],
            },
            isCheckAll: false,
        }
    },

    created() {
        this.fetchRoleAndPermissionData();
    },
    

    methods: {

        fetchRoleAndPermissionData() {
            axios.get(this.apiUrl+'/roles/'+this.role_id+'/permission', this.headerjson)
            .then((res) => {
                this.role = res.data.data.role;
                this.menu_and_permissions = res.data.data.menu_and_permissions;
                this.form.role_permissions = res.data.data.role.role_permissions;
                this.form.module_permissions = res.data.data.module_permissions;
                this.form.sub_module_permissions = res.data.data.sub_module_permissions;
                this.sub_modules = res.data.data.sub_modules;
                this.permissions    = res.data.data.permissions;

                if(this.form.module_permissions.length == this.menu_and_permissions.length) {
                    this.isCheckAll = true;
                }else{
                    this.isCheckAll = false;
                }
            })
            .catch()
            .finally((fres) => {
                this.loading = false;
            });
        },

        checkedAll(checked){
            if(checked){ 
                this.isCheckAll = true;
                for (let i = 0; i < this.menu_and_permissions.length; i++) { 
                    var module_permission_id = parseInt(this.menu_and_permissions[i].id);
                    const m_index = this.form.module_permissions.indexOf(module_permission_id);
                    if(m_index == -1) {
                        this.form.module_permissions.push(module_permission_id);
                    }

                    for(let s = 0; s < this.menu_and_permissions[i].sub_modules.length; s++){
                        var sub_module_id = parseInt(this.menu_and_permissions[i].sub_modules[s].id);
                        const index = this.form.sub_module_permissions.indexOf(sub_module_id)
                        if(index == -1) {
                            this.form.sub_module_permissions.push(sub_module_id);
                        }

                        for(let sa = 0; sa < this.menu_and_permissions[i].sub_modules[s].actions.length; sa++){
                            var permission_id = parseInt(this.menu_and_permissions[i].sub_modules[s].actions[sa].id);
                            const index = this.form.role_permissions.indexOf(permission_id)
                            if(index == -1) {
                                this.form.role_permissions.push(permission_id)
                            }
                        }
                    }

                    for(let j = 0; j < this.menu_and_permissions[i].actions.length; j++){
                        var mpermission_id = parseInt(this.menu_and_permissions[i].actions[j].id);
                        const index = this.form.role_permissions.indexOf(mpermission_id);
                        if(index == -1) {
                            this.form.role_permissions.push(mpermission_id);
                        }
                    }
                }   

            }else{
                this.isCheckAll = false;
                this.form.role_permissions = [];
                this.form.module_permissions = [];                    
                this.form.sub_module_permissions = [];                    
            }
            
        },

        checkModule(event) {
            if(event.target._modelValue.length == this.menu_and_permissions.length) {
                this.isCheckAll = true;
            }else{
                this.isCheckAll = false;
            }
            let checked = event.target.checked;
            let j;
            var s;
            var sa;
            if(checked) {
                if(event.target.value in this.sub_modules) {
                    

                    for(s=0; s<this.sub_modules[event.target.value].length; s++) {
                        var csub_module_id = parseInt(this.sub_modules[event.target.value][s]);
                        const index = this.form.sub_module_permissions.indexOf(csub_module_id);
                        if(index == -1) {
                            this.form.sub_module_permissions.push(csub_module_id);
                        }

                        if(this.sub_modules[event.target.value][s] in this.permissions) {
                            for(sa = 0; sa < this.permissions[this.sub_modules[event.target.value][s]].length; sa++) {
                                var smpermission_id = parseInt(this.permissions[this.sub_modules[event.target.value][s]][sa].id);
                                const index = this.form.role_permissions.indexOf(smpermission_id);
                                if(index == -1) {
                                    this.form.role_permissions.push(smpermission_id);
                                }
                            }
                        }
                    }

                }

                if(event.target.value in this.permissions) {
                    for(j = 0; j < this.permissions[event.target.value].length; j++) {
                        var mpermission_id = parseInt(this.permissions[event.target.value][j].id);
                        const index = this.form.role_permissions.indexOf(mpermission_id);
                        if(index == -1) {
                            this.form.role_permissions.push(mpermission_id);
                        }
                    }
                }
            }else{
                if(event.target.value in this.sub_modules) {

                    for(s=0; s<this.sub_modules[event.target.value].length; s++) {
                        var usub_module_id = parseInt(this.sub_modules[event.target.value][s]);
                        const index = this.form.sub_module_permissions.indexOf(usub_module_id);
                        if(index > -1) {
                            this.form.sub_module_permissions.splice(index, 1);
                        }

                        if(this.sub_modules[event.target.value][s] in this.permissions) {
                            for(sa = 0; sa < this.permissions[this.sub_modules[event.target.value][s]].length; sa++) {
                                var sm_permission_id = parseInt(this.permissions[this.sub_modules[event.target.value][s]][sa].id); 
                                const index = this.form.role_permissions.indexOf(sm_permission_id);
                                if(index > -1) {
                                    this.form.role_permissions.splice(index, 1);
                                }
                            }
                        }
                    }


                }

                if(event.target.value in this.permissions) {
                    for(j = 0; j < this.permissions[event.target.value].length; j++) {
                        var umpermission_id  = parseInt(this.permissions[event.target.value][j].id);
                        const index = this.form.role_permissions.indexOf(umpermission_id);
                        if(index > -1) {
                            this.form.role_permissions.splice(index, 1);
                        }
                    }
                }
            }
        },

        checkSubModule(event) {
            let checked = event.target.checked;
            let module_id = parseInt(event.target.getAttribute('refs'));
            let j;
            let s;
            if(checked) {
                var sub_module_count = 0;
                for(s=0; s<this.sub_modules[module_id].length; s++) {
                    var sub_module_id = parseInt(this.sub_modules[module_id][s]);
                    const index = this.form.sub_module_permissions.indexOf(sub_module_id);
                    if(index == -1) {
                        sub_module_count++;
                    }
                }
                if(sub_module_count == 0) {
                    this.form.module_permissions.push(module_id);
                }

                for(j = 0; j < this.permissions[event.target.value].length; j++) {
                    var smpermission_id = parseInt(this.permissions[event.target.value][j].id);
                    const index = this.form.role_permissions.indexOf(smpermission_id);
                    if(index == -1) {
                        this.form.role_permissions.push(smpermission_id);
                    }
                }
            }else{
                for(j = 0; j < this.permissions[event.target.value].length; j++) {
                    var usmpermission_id = parseInt(this.permissions[event.target.value][j].id);
                    const index = this.form.role_permissions.indexOf(usmpermission_id);
                    if(index > -1) {
                        this.form.role_permissions.splice(index, 1);
                    }
                }

                const sindex = this.form.sub_module_permissions.indexOf(parseInt(event.target.value));
                if(sindex > -1) {
                    this.form.sub_module_permissions.splice(sindex, 1);
                }

                const mindex = this.form.module_permissions.indexOf(module_id);
                if(mindex > -1) {
                    this.form.module_permissions.splice(mindex, 1);
                }
                
            }


            if(this.form.module_permissions.length == this.menu_and_permissions.length) {
                this.isCheckAll = true;
            }else{
                this.isCheckAll = false;
            }

        },

        checkSinglePermission(event) {

            let checked = event.target.checked;
            let module_id   = parseInt(event.target.getAttribute("refs"));
            let type = event.target.getAttribute("child_type");
            let parent_module_id = parseInt(event.target.getAttribute("parent_id"));

            let mod_permissions = this.permissions[module_id];
            let checked_array = [];
            for(let i = 0; i < mod_permissions.length; i++) {

                const index = this.form.role_permissions.indexOf(mod_permissions[i].id);
                if(index > -1) {
                    checked_array.push(mod_permissions[i].id);
                }
            }

            if(checked) {
                if(type =="sub_module") {
                    if(mod_permissions.length == checked_array.length) {
                        const m_index = this.form.sub_module_permissions.indexOf(module_id);
                        if(m_index == -1) {
                            this.form.sub_module_permissions.push(module_id);
                        }
                    }

                    var sub_module_count = 0;
                    for(let s=0; s<this.sub_modules[parent_module_id].length; s++) {
                        var sub_module_id = parseInt(this.sub_modules[parent_module_id][s]);
                        const index = this.form.sub_module_permissions.indexOf(sub_module_id);
                        if(index == -1) {
                            sub_module_count++;
                        }
                    }

                    if(sub_module_count == 0) {
                        this.form.module_permissions.push(parent_module_id);
                    }

                }else{
                    if(mod_permissions.length == checked_array.length) {
                        const m_index = this.form.module_permissions.indexOf(module_id);
                        if(m_index == -1) {
                            this.form.module_permissions.push(parent_module_id);
                        }
                    }
                }

            }else{
                if(type == "sub_module") {
                    const m_index = this.form.module_permissions.indexOf(parent_module_id);
                    if(m_index > -1) {
                        this.form.module_permissions.splice(m_index, 1);
                    }

                    const s_index = this.form.sub_module_permissions.indexOf(module_id);
                    if(s_index > -1) {
                        this.form.sub_module_permissions.splice(s_index, 1);
                    }
                }else{
                    const m_index = this.form.module_permissions.indexOf(module_id);
                    if(m_index > -1) {
                        this.form.module_permissions.splice(m_index, 1);
                    }
                }
            }
            

            if(this.form.module_permissions.length == this.menu_and_permissions.length) {
                this.isCheckAll = true;
            }else{
                this.isCheckAll = false;
            }

        },


        // edit: function(item) {
        //     this.btn='Update';
        //     this.editMode = true;
        //     this.toggleModal();
        //     this.form.fill(item); 
        // },
        submitForm: function(e) {            
            this.isSubmit = true;
            this.disabled = true;
            var api_url = this.apiUrl;
            var auth_headers = this.headerjson;
            
            var postEvent = axios.post(this.apiUrl+'/roles/'+this.role_id+'/permission', this.form, this.headerjson);

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.$toast.success(res.data.message); 
                    this.$store.dispatch('getUserMenuAndPermissions', {api_url, auth_headers});
                    // this.$router.push('/role');
                    // this.$router.go(-1);
                    //window.location.href = '/role';
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                console.log(err.response.data.message);
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            });
              
        },
        
    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {},
}
</script>

<style scoped>
/* Divider helper */
.vertical-divider {
    width: 1px;
    height: 16px;
    background-color: #cbd5e1;
}

/* Checkbox Label styles */
.select-all-label {
    color: #475569 !important;
    font-size: 12.5px !important;
}

.form-checkbox-premium input[type="checkbox"] {
    display: inline-block !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: static !important;
    left: auto !important;
    width: 16px !important;
    height: 16px !important;
    cursor: pointer;
    margin-right: 8px;
    vertical-align: middle;
    appearance: auto !important;
    -webkit-appearance: auto !important;
}
.form-checkbox-premium {
    cursor: pointer;
    user-select: none;
    font-size: 13.5px;
    font-weight: 550;
    color: #334155;
}
.form-checkbox-premium:hover {
    color: #4f46e5;
}


.module-cell {
    background-color: #f8fafc !important;
}

.submodule-cell {
}

.italic {
    font-style: italic;
}
</style>